var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      staticClass: "sl-modal",
      attrs: {
        id: "jobModal",
        "no-esc-dismiss": true,
        "no-backdrop-dismiss": true,
        "content-css": { width: "1000px", height: "600px" }
      },
      model: {
        value: _vm.jobModalOpen,
        callback: function($$v) {
          _vm.jobModalOpen = $$v
        },
        expression: "jobModalOpen"
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c(
                "q-toolbar-title",
                [
                  _c("q-icon", { attrs: { name: "fa fa-clipboard" } }),
                  _vm._v(
                    "\n        Roster Job " +
                      _vm._s(_vm.job.ROSTER_JOB_ID) +
                      "\n      "
                  )
                ],
                1
              ),
              _c("q-icon", {
                attrs: { name: "clear" },
                nativeOn: {
                  click: function($event) {
                    _vm.setJobModalOpen(false)
                  }
                }
              })
            ],
            1
          ),
          _c("div", { staticClass: "sl-row header-row" }, [
            _c("div", { staticClass: "sl-col-2" }, [
              _c("label", [_vm._v("Job Number")]),
              _vm._v(
                "\n          #" + _vm._s(_vm.job.ROSTER_JOB_ID) + "\n      "
              )
            ]),
            _c("div", { staticClass: "sl-col-3" }, [
              _c("label", [_vm._v("Date Started")]),
              _vm._v("\n        " + _vm._s(_vm.job.DATE_CREATED) + "\n      ")
            ]),
            _c("div", { staticClass: "sl-col-3" }, [
              _c("label", [_vm._v("Started By")]),
              _c("div", { staticClass: "label green round" }, [
                _c("span", [_vm._v(_vm._s(_vm.startedByInitials))])
              ]),
              _vm._v("\n        " + _vm._s(_vm.startedBy) + "\n      ")
            ]),
            _c("div", { staticClass: "sl-col-2" }, [
              _c("label", [_vm._v("Job Status")]),
              _c(
                "div",
                {
                  staticClass: "label",
                  class: {
                    blue: _vm.job.statusText == "Processing",
                    purple: _vm.job.statusText == "Ready for Review",
                    yellow: _vm.job.statusText == "In Review",
                    green: _vm.job.statusText == "Completed",
                    red: _vm.job.statusText == "Error"
                  },
                  staticStyle: {
                    display: "inline-block",
                    "border-radius": "30px"
                  }
                },
                [_vm._v(_vm._s(_vm.job.statusText))]
              )
            ]),
            _c("div", { staticClass: "sl-col-2" }, [
              _c("label", [_vm._v("Approval Status")]),
              _vm.job.approvalStatus
                ? _c(
                    "div",
                    {
                      staticClass: "label",
                      class: {
                        blue:
                          _vm.job.approvalStatus == "SUBMITTED" ||
                          _vm.job.approvalStatus == "RESUBMITTED",
                        green: _vm.job.approvalStatus == "APPROVED",
                        red: _vm.job.approvalStatus == "REJECTED",
                        yellow: _vm.job.approvalStatus == "EXPIRED",
                        grey: _vm.job.approvalStatus == "NOT SUBMITTED",
                        purple: _vm.job.approvalStatus == "COMPLETED"
                      },
                      staticStyle: {
                        display: "inline-block",
                        "border-radius": "30px",
                        "text-transform": "capitalize"
                      }
                    },
                    [_vm._v(_vm._s(_vm.job.approvalStatus.toLowerCase()))]
                  )
                : _c("span", [_vm._v("N/A")])
            ])
          ]),
          _c("div", { staticClass: "q-mx-lg" }, [
            _c(
              "div",
              {
                staticClass: "sl-row",
                staticStyle: { "font-size": "15px", "margin-bottom": "0" }
              },
              [
                _c("div", { staticClass: "sl-col-6" }, [
                  _c("div", { staticClass: "section-header" }, [
                    _c(
                      "h5",
                      { staticClass: "inline" },
                      [
                        _c("q-icon", {
                          attrs: { name: "book", color: "primary" }
                        }),
                        _vm._v(" Details")
                      ],
                      1
                    )
                  ]),
                  _c("div", [
                    _c("b", [_vm._v("Class ID")]),
                    _vm._v(": " + _vm._s(_vm.job.CLASS_ID))
                  ]),
                  _c("div", [
                    _c("b", [_vm._v("Document Name")]),
                    _vm._v(
                      ": " +
                        _vm._s(
                          _vm.job.DOCUMENT
                            ? _vm.job.DOCUMENT.DOCUMENT_NAME
                            : "N/A"
                        )
                    )
                  ]),
                  _c("div", [
                    _c("b", [_vm._v("Number of Students")]),
                    _vm._v(
                      ": " +
                        _vm._s(_vm.draftStudents && _vm.draftStudents.length)
                    )
                  ])
                ]),
                _vm.job.ROSTER_JOB_STATUS === 4
                  ? _c("div", { staticClass: "sl-col-6" }, [
                      _c("div", { staticClass: "section-header" }, [
                        _c(
                          "h5",
                          { staticClass: "inline" },
                          [
                            _c("q-icon", {
                              attrs: { name: "error", color: "red" }
                            }),
                            _vm._v(" Error Notes")
                          ],
                          1
                        )
                      ]),
                      _c("div", { staticClass: "claudeNotes" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.job.ERROR_NOTES) +
                            "\n          "
                        )
                      ])
                    ])
                  : _c("div", { staticClass: "sl-col-6" }, [
                      _c("div", { staticClass: "section-header" }, [
                        _c(
                          "h5",
                          { staticClass: "inline" },
                          [
                            _c("q-icon", {
                              attrs: { name: "comment", color: "primary" }
                            }),
                            _vm._v(" Notes from AI")
                          ],
                          1
                        )
                      ]),
                      _c("div", { staticClass: "claudeNotes" }, [
                        _vm._v(
                          "\n            " + _vm._s(_vm.notes) + "\n          "
                        )
                      ])
                    ]),
                _c("div", { staticClass: "clearfix" })
              ]
            )
          ]),
          _c(
            "q-toolbar",
            {
              staticClass: "sl-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("q-toolbar-title"),
              _vm.showReviewBtn
                ? _c("q-btn", {
                    staticStyle: { "margin-right": "3px" },
                    attrs: { color: "green", label: "Review" },
                    on: {
                      click: function($event) {
                        _vm.review()
                      }
                    }
                  })
                : _vm._e(),
              _c("q-btn", {
                attrs: { outline: "", color: "faded", label: "Close" },
                on: {
                  click: function($event) {
                    _vm.setJobModalOpen(false)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.draftStudentModalOpen ? _c("draft-student-modal") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }